import { Card, Link, Typography } from '@mui/joy';
import React, { useState, useEffect } from 'react';
import { animated } from '@react-spring/web';
import { useMobileMode } from './Responsive';

export default function Salam() {
  const mobile = useMobileMode();
  const [showBanner, setShowBanner] = useState(true);

  // check if the current path is the homepage
  const isHomePage = window.location.pathname === '/';

  // hide the banner on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowBanner(false); // hide when scrolled down
      } else {
        setShowBanner(true); // show when scrolled to the top
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Ensure banner only appears on the homepage and when it's visible (not scrolled down)
  return isHomePage && showBanner ? (
    <Card
      component={animated.div}
      sx={(theme) => ({
        position: 'fixed',
        top: 'var(--nav-safe-area-inset-top, 0)',
        right: '0',
        width: mobile ? '100vw' : undefined,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'row',
        borderRadius: 0,
        borderBottomLeftRadius: mobile ? undefined : '1rem',
        padding: '0.5rem 1rem',
        backgroundColor: `color-mix(in srgb, ${theme.palette.background.body}, transparent 20%)`,
        backdropFilter: 'blur(10px)',
        overflow: 'auto',
      })}
    >
      <Typography
        level="body3"
        sx={{
          whiteSpace: 'nowrap',
          fontFamily: 'Reem Kufi',
        }}
      >
        <Link href="https://github.com/iibrahemali" target="_blank">
          .إِبرَاهِيم
        </Link>
        {' '}
        السلامُ عليكم ورحمةُ اللهِ وبركاتُهُ، أنا
      </Typography>
    </Card>
  ) : null;
}
